<div class="modal-container">
  <div class="logo-container">
    <img src="../../../../../assets/img/logo-header.png" />
  </div>

  <form [formGroup]="form" (ngSubmit)="submit()">
    <input
      type="text"
      [class.is-invalid]="
        form.get('email').invalid && form.get('email').touched
      "
      class="form-control mt-10"
      formControlName="email"
      placeholder="{{ 'email' | translate }} *"
    />

    <div class="captcha-container">
      <img [src]="imgCaptcha" alt="captcha" class="captcha-image" />
      <a (click)="generateCaptcha()" class="reload-link">
        {{ "global.newsForm.reloadImg" | translate }}
      </a>
    </div>

    <input
      formControlName="inputCaptcha"
      class="form-control"
      placeholder="{{ 'global.newsForm.captchaPlaceholder' | translate }}"
      type="text"
    />

    <label
      class="mt-2"
      style="color: red;"
      for=""
      *ngIf="errorCaptcha && form.controls.inputCaptcha.value == ''"
      >{{ "global.newsForm.verificationText" | translate }}</label
    >
    <label
      class="mt-2"
      style="color: red;"
      for=""
      *ngIf="
        errorCaptcha &&
        form.controls.inputCaptcha.value != '' &&
        form.controls.inputCaptcha.value != textCaptcha
      "
      >{{ "global.newsForm.verifyText" | translate }}</label
    >

    <button
      mat-button
      color="warn"
      class="subscribe-btn mt-3"
      type="submit"
      [disabled]="form.invalid"
    >
      {{ "global.newsForm.subscribe" | translate }}
    </button>
  </form>
</div>
